// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"486116ba","453":"cdd00e3a","706":"7b1ed330"}[chunkId] + ".chunk.js";
};